import React, {useMemo, useState} from "react";
import {Spinner} from "../../../../shared";
import users from "../../../../users";
import {useSelector} from "react-redux";

import './seasonDetails.scss';
import {cn, getLocalDateString, isFutureDate} from "../../../../../utils/utils";
import {useNavigate} from "react-router-dom";
import TmdbImage from "../../../../shared/tmdb-image/tmdb-image";
import UseUserPreferences from "../../../../user-app-config/hooks/use-user-preferences";
import SpoilersPreferenceModal from "../../spoilers-preference-modal/spoilers-preference-modal";
import {ScrollModal} from "../../../../shared/scroll-modal";
import {OptionButton} from "../../../../shared/option-button";
import TmdbLikeItem from "../../tmdbLikeItem/tmdb-like-item";
import TmdbNotepad from "../../tmdbNotepad/tmdbNotepad";
import ItemBackdropDetails from "../../../shared/item-backdrop-details/item-backdrop-details";
import useSeasonEpisodesData from "../../../hooks/useSeasonEpisodesData";

function SeasonDetails({seasonNumber, serie, forceSmall, selectedEpisode}) {

    const darkMode = useSelector(users.selectors.isDarkMode);
    const navigate = useNavigate();
    const {userPreferences, loading: loadingPreferences} = UseUserPreferences();
    const optionsModalApi = React.useRef(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const {
        season,
        loading,
        updateItemInSeason,
        markEpisodeAsView
    } = useSeasonEpisodesData(serie, seasonNumber);

    const isSpoilerForItem = useMemo(() => {
        if (!selectedItem) return true;
        return (userPreferences.hideSpoilers || userPreferences.hideSpoilers == null || loadingPreferences) && !selectedItem.view;
    }, [selectedItem, userPreferences, loadingPreferences]);

    if (loading) {
        return (
            <center className="mt-4">
                <Spinner></Spinner>
            </center>
        )
    }

    return (
        <div
            className={cn("mt-4 season-details", {"season-details--dark": darkMode}, {"season-details--small": forceSmall})}>
            <div className="season-details__episodes">
                {season.episodes.map(episode => {
                    const isSpoiler = (userPreferences.hideSpoilers || userPreferences.hideSpoilers == null || loadingPreferences) && !episode.view;
                    return (
                        <ItemBackdropDetails
                            className="season-details__episodes--item"
                            key={episode.episode_number + "_" + episode.view}
                            overlay={{
                                bottomLeft: episode.notes ? <><i
                                    className="fa-solid fa-note-sticky"></i></> : undefined,
                                bottomRight: episode.view ? <>Visto <i
                                    className="fa-solid fa-eye"></i></> : undefined,
                            }} onClickPoster={() => {
                            navigate(`/squadflix/series/${serie.id}/${season.season_number}/${episode.episode_number}`);
                        }} onClickDetails={() => {
                            setSelectedItem(null);
                            requestAnimationFrame(() => {
                                setSelectedItem(episode);
                                optionsModalApi.current.open();
                            });
                        }} tmdbSrc={episode.still_path}
                            isSpoiler={isSpoiler}
                            detailsTitle={<>
                                {!isSpoiler && <>
                                    <span
                                        className="season-details__episodes--item-title-number">E{episode.episode_number}. </span>
                                    <span
                                        className="season-details__episodes--item-title-name">{episode.name}</span>
                                </>}
                                {isSpoiler && <span className="season-details__episodes--item-title-number">
                                        Episodio {episode.episode_number}
                                    </span>}
                            </>}
                            detailsSubtitle={<>

                                        <span
                                            className="season-details__episodes--item-info-airdate">{getLocalDateString(episode.air_date)}</span>
                                <span
                                    className="season-details__episodes--item-info-runtime">
                                            &nbsp;· {isFutureDate(episode.air_date) ? "Proximamente!" : <>{episode.runtime} min</>}
                                        </span>
                            </>}/>
                    )
                })}
                {season.episodes?.length % 3 === 2 && <div className="season-details__episodes--item"></div>}
            </div>
            <ScrollModal ref={optionsModalApi} header={selectedItem && <div
                className="d-flex gap-3 mb-2 align-items-start">
                <div>
                    <TmdbImage src={serie.poster_path} size="w500" style={{
                        height: "120px",
                    }}/>
                </div>
                <div className="">
                    {!isSpoilerForItem && <div className="season-details__episodes--item-title mt-0">
                                        <span
                                            className="season-details__episodes--item-title-number">E{selectedItem.episode_number}. </span>
                        <span
                            className="season-details__episodes--item-title-name">{selectedItem.name}</span>
                    </div>}
                    {isSpoilerForItem && <div className="season-details__episodes--item-title mt-0">
                                        <span
                                            className="season-details__episodes--item-title-number">Episodio {selectedItem.episode_number}</span>
                    </div>}
                    <div className="season-details__episodes--item-info text-muted">
                                        <span
                                            className="season-details__episodes--item-info-airdate">{getLocalDateString(selectedItem.air_date)}</span>
                        <span
                            className="season-details__episodes--item-info-runtime">
                                            &nbsp;· {isFutureDate(selectedItem.air_date) ? "Proximamente!" : <>{selectedItem.runtime} min</>}
                                        </span>
                    </div>
                    {!isSpoilerForItem && <div className="mt-2">
                        <i className="text-muted">{selectedItem.overview || "Sin descripción disponible."}</i>
                    </div>}
                    {isSpoilerForItem && <div className="mt-2">
                        <i className="text-muted">Modo sin spoilers, se mostrará el resumen una vez visto el
                            episodio.</i>
                    </div>}
                </div>
            </div>}>
                <OptionButton text="Abrir notas" icon={<i className="fa-solid fa-note-sticky fa-lg"></i>}
                              onClick={() => {
                                  navigate("#episode-notes");
                                  optionsModalApi.current.close();
                              }}/>
                <OptionButton text={selectedItem?.view ? "Marcar como no visto" : "Marcar como visto"} icon={
                    selectedItem?.view
                        ? <i className="fa-solid fa-eye-slash fa-lg"></i>
                        : <i className="fa-solid fa-eye fa-lg"></i>
                } onClick={() => {
                    if (!selectedItem) return;
                    markEpisodeAsView(selectedItem, !selectedItem.view, () => {
                        setSelectedItem({...selectedItem, view: !selectedItem.view});
                        updateItemInSeason({...selectedItem, view: !selectedItem.view});
                    });
                }}/>
                <OptionButton text="Añadir reseña" icon={<i className="fa-solid fa-star fa-lg"></i>}
                              onClick={() => {
                                  navigate("#episode-review");
                                  optionsModalApi.current.close();
                              }}/>
                <div style={{display: "none"}}>
                    {selectedItem &&
                        <TmdbNotepad tmdbItem={{...selectedItem, serie: serie}}
                                     customUrl={'#episode-notes'} onClose={(notes) => {
                            updateItemInSeason({...selectedItem, notes: notes});
                            setSelectedItem(null);
                        }}/>}
                    {selectedItem &&
                        <TmdbLikeItem tmdbItem={{...selectedItem, serie: serie}}
                                      customUrl={'#episode-review'} onClose={() => {
                            setSelectedItem(null);
                        }}/>}
                </div>
            </ScrollModal>
            <SpoilersPreferenceModal serie={serie}/>
        </div>
    )
}

export default SeasonDetails;
